import React from "react";
import shortid from "shortid";
import { Link, Navigate } from "react-router-dom";
import { SignUpInput, CompanyView, Country, Branch, Department, Gender, TimeZoneInfoView, Roles } from "../../../models/general";
import { addUpdateBranches, addUpdateDepartments, getBranches, getCompanies, getDepartments } from "../../../api/General/Company";
import { getCountries, getTimeZones } from "../../../api/General/Country";
import { pickTimezoneForCountry } from "../../../utils/countryTimezones";
import { addUsers, getRoles } from "../../../api/General/account";
import { withTranslation } from "react-i18next";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { connect } from "react-redux";
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import { Checkbox } from '../../../components/ui/Checkbox';
import { DatePicker as CustomDatePicker } from '../../../components/dateTimePickers';
import { getTemplates } from '../../../api/Employee/lifecycleTemplates';
import { getEmployeeSelections, startOnboarding } from '../../../api/Employee/onboardingProcesses';
import type { LifecycleTemplateView, EmployeeSelectionView } from '../../../models/employee';
import { TemplateCategory } from '../../../models/employee';


const days = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
]

interface IUserInput extends SignUpInput {
  weekends: number[];
  id: string;
  // company?: CompanyView;
  country?: Country;
}

interface IState {
  item: IUserInput;
  companies: CompanyView[];
  lastSelectedCompany?: CompanyView;
  countries: Country[];
  lastSelectedCountry?: Country;
  dialogVisible: boolean;
  roles: string[];
  branches: Branch[];
  departments: Department[];
  errorMessage: string;
  success: boolean;
  timeZones: TimeZoneInfoView[];
  onboardingTemplates: LifecycleTemplateView[];
  selectedOnboardingTemplateId: string;
  onboardingStartDate: string;
  onboardingManagerId: string;
  managers: EmployeeSelectionView[];
  isSubmitting: boolean;
}

interface IProps {
  history: any,
  t: any,
  userId?: any,
  companyName?: any,
  company?: any,
  role?: any,
  companyPrimaryColor?: any
}


class AddUser extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = {
      dialogVisible: false,
      item:
      {
        companyId: 0,
        id: shortid.generate(),
        employeeId: "",
        email: "",
        password: `${shortid.generate()}@Abc123`,
        countryId: 0,
        role: "",
        branchId: 0,
        departmentId: 0,
        title: "",
        firstName: "",
        lastName: "",
        phoneNumber: "",
        weekends: [],
        //workingHours: 9,
        //startTime: "",
        //endTime: "",
        //weekendsDelimited: "",
        linkedInUrl: "",
        birthDate: new Date(),
        gender: Gender.Male,
        timeZone: "",
        sendWelcomeEmail: true
      },
      companies: [],
      countries: [],
      roles: [],
      branches: [],
      departments: [],
      errorMessage: "",
      success: false,
      timeZones: [],
      onboardingTemplates: [],
      selectedOnboardingTemplateId: '',
      onboardingStartDate: '',
      onboardingManagerId: '',
      managers: [],
      isSubmitting: false,
    };
  }

  componentDidMount() {
    this.fetch();

  }

  onFormatDate = (date?: Date): string => {
    return !date ? '' : !date ? '' : (date.getFullYear()) + '-' + (date.getMonth() + 1) + '-' + date.getDate();
  };

  fetch = async () => {
    if (this.props.role === Roles.Operator)
      await this.fetchCompanies();
    await this.fetchCountries();
    await this.fetchRoles();
    await this.fetchBranchesAndDepartments();
    await this.fetchTimeZones();
    await this.fetchOnboardingTemplates();
    await this.fetchManagerSelections();
  }

  /* Utility: identify which required fields are missing for UX feedback */
  getMissingRequired = () => {
    const { item, selectedOnboardingTemplateId, onboardingStartDate, onboardingManagerId } = this.state;
    const missing: string[] = [];
    if (!item.firstName) missing.push('firstName');
    if (!item.lastName) missing.push('lastName');
    if (!item.email) missing.push('email');
    if (!item.countryId) missing.push('countryId');
    if (!item.role) missing.push('role');
    if (!item.timeZone) missing.push('timeZone');
    if (item.gender === undefined || item.gender === null) missing.push('gender');
    if (selectedOnboardingTemplateId) {
      if (!onboardingStartDate) missing.push('onboardingStartDate');
      if (!onboardingManagerId) missing.push('onboardingManagerId');
    }
    return missing;
  }

  fetchRoles = async () => {
    const { payload } = await getRoles();
    this.setState({ roles: payload });
  }

  fetchCountries = async () => {
    const { payload } = await getCountries();
    this.setState({ countries: payload });
  };
  fetchTimeZones = async () => {
    const timeZones = await getTimeZones();
    //console.log(timeZones.payload)
    this.setState({ timeZones: timeZones.payload });
  };

  fetchOnboardingTemplates = async () => {
    const result = await getTemplates(TemplateCategory.Onboarding);
    if (!result.errors || result.errors.length === 0) {
      this.setState({ onboardingTemplates: result.payload || [] });
    }
  }

  fetchManagerSelections = async () => {
    const result = await getEmployeeSelections();
    if (!result.errors || result.errors.length === 0) {
      this.setState({ managers: result.payload || [] });
    }
  }

  fetchCompanies = async () => {
    const { payload } = await getCompanies();
    this.setState({ companies: payload });
  };

  fetchBranchesAndDepartments = async () => {
    let companyId = this.props.company?.id ?? 0
    if (this.state.lastSelectedCompany?.id) {
      companyId = this.state.lastSelectedCompany?.id
    }
    const branches = await getBranches(companyId)
    this.setState({ branches: branches.payload });
    const departments = await getDepartments(companyId)
    this.setState({ departments: departments.payload });
  };

  submit = async () => {
    const { t } = this.props;
    if (this.state.isSubmitting) return;
    try {
      if (typeof window !== 'undefined' && window.scrollTo) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      const items = [this.state.item];
      const filteredItems = items.filter(item => !(item.countryId && item.email && item.lastName && item.role && item.timeZone && item.gender));
      if (filteredItems.length > 0) {
        this.setState({ dialogVisible: true, errorMessage: t('Please fill all required fields') });
        return;
      }

      this.setState({ isSubmitting: true, dialogVisible: false, errorMessage: '' });
      const users = await addUsers(items);
      if (users && (!users.errors || users.errors.length === 0)) {
        if (this.state.selectedOnboardingTemplateId && users.payload && users.payload.length > 0) {
          const newUserId = users.payload[0];
          const onboardingResult = await startOnboarding({
            userId: newUserId,
            templateId: parseInt(this.state.selectedOnboardingTemplateId, 10),
            startDate: this.state.onboardingStartDate,
            managerId: this.state.onboardingManagerId,
          });
          if (onboardingResult.errors && onboardingResult.errors.length > 0) {
            this.setState({ dialogVisible: true, errorMessage: onboardingResult.errors[0]?.message || t('Failed to start onboarding') });
            return;
          }
        }
        this.setState({ success: true });
      } else if (users?.errors && users.errors.length > 0) {
        this.setState({ dialogVisible: true, errorMessage: users.errors[0]?.message || t('Failed to add user') });
      }
    } catch (error: any) {
      console.log("error: ", error);
      this.setState({ dialogVisible: true, errorMessage: t(error.errors?.[0]?.description || 'An unexpected error occurred') });
    } finally {
      this.setState({ isSubmitting: false });
    }
  };

  render() {
    const { t } = this.props;
    if (this.state.success == true) {
      return <Navigate to={`/core-hr/directory`} />
    }
    const missing = this.getMissingRequired();
    const isMissing = (name: string) => missing.includes(name);
    return (
      <>
        {this.state.dialogVisible && (
          <div className="w-full mb-4">
            <div className="rounded-lg border border-destructive/50 bg-destructive/10 p-4 text-sm text-destructive flex items-center justify-between">
              <span>{t("Failed to add users. ") + this.state.errorMessage}</span>
              <button onClick={() => this.setState({ dialogVisible: false })} className="ms-2 hover:opacity-80">&times;</button>
            </div>
          </div>
        )}
        <div className="flex flex-col items-center gap-6 p-4">
          <div className="w-full flex flex-col gap-4">
            <div className="flex flex-col gap-1 mb-2">
              <h1 className="heading-2">
                {t("New Employee")}
              </h1>
              <p className="text-sm text-muted">
                {t("Fill in the required details below. Fields marked with * are mandatory.")}
              </p>
            </div>
            <hr className="border-border" />
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Basic Information */}
              <div>
                <div className="section h-full">
                  <h3 className="text-sm text-primary mb-2 font-semibold">{t('Basic Information')}</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <Input label={t("First Name")} value={this.state.item.firstName} required error={isMissing('firstName') ? t('Required') : undefined} onChange={(ev: any) => { const item = { ...this.state.item, firstName: (ev.target as HTMLInputElement).value }; this.setState({ item }); }} />
                    </div>
                    <div>
                      <Input label={t("Last Name")} value={this.state.item.lastName} required error={isMissing('lastName') ? t('Required') : undefined} onChange={(ev: any) => { const item = { ...this.state.item, lastName: (ev.target as HTMLInputElement).value }; this.setState({ item }); }} />
                    </div>
                    <div>
                      <Select
                        label={t("Gender")}
                        required
                        error={isMissing('gender') ? t('Required') : undefined}
                        options={Object.values(Gender).filter(v => isNaN(Number(v))).map((key: any) => ({ label: t(key), value: (Gender as any)[key] }))}
                        value={this.state.item.gender}
                        onChange={(value: any) => { const item = { ...this.state.item, gender: value as Gender }; this.setState({ item }); }}
                      />
                    </div>
                    <div>
                      <CustomDatePicker label={t("Birth Date")} value={this.state.item.birthDate ? this.state.item.birthDate : null} onChange={(date: any) => { const item = { ...this.state.item, birthDate: date ?? undefined }; this.setState({ item }); }} fullWidth={true} />
                    </div>
                  </div>
                </div>
              </div>

              {/* Contact & Location */}
              <div>
                <div className="section h-full">
                  <h3 className="text-sm text-primary mb-2 font-semibold">{t('Contact & Location')}</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <Input label={t("Email")} type="email" value={this.state.item.email} required error={isMissing('email') ? t('Required') : undefined} onChange={(ev: any) => { const item = { ...this.state.item, email: (ev.target as HTMLInputElement).value }; this.setState({ item }) }} />
                    </div>
                    <div>
                      <div className={`phone-field ${isMissing('phoneNumber') ? 'is-error' : ''}`}>
                        <label className="text-sm font-semibold mb-0.5 block">{t("Phone Number")}</label>
                        <PhoneInput title={t("Phone Number")} international className="w-full" value={this.state.item.phoneNumber} onChange={(ev: any) => { const item = { ...this.state.item, phoneNumber: ev }; this.setState({ item }) }} />
                      </div>
                    </div>
                    <div>
                      <Select
                        label={t("Country")}
                        required
                        searchable
                        error={isMissing('countryId') ? t('Required') : undefined}
                        options={this.state.countries.map(x => ({ label: x.name, value: x.id }))}
                        value={this.state.item.countryId || ''}
                        onChange={(value: any) => {
                          const selectedId = value;
                          const selectedCountry = this.state.countries.find(x => x.id === selectedId);
                          const item = { ...this.state.item, country: selectedCountry, countryId: parseInt(String(selectedId)) };
                          if (selectedCountry && (!item.phoneNumber || item.phoneNumber.length < 6)) {
                            item.phoneNumber = '+' + selectedCountry.phoneCode;
                          }
                          // Auto-populate the timezone when the user hasn't picked one yet.
                          // Multi-zone countries (US, RU, CA, AU, BR, …) are intentionally
                          // skipped — the helper returns null and the user picks manually.
                          if (selectedCountry && !item.timeZone) {
                            const tz = pickTimezoneForCountry(selectedCountry.iso, this.state.timeZones);
                            if (tz) item.timeZone = tz;
                          }
                          this.setState({ item });
                        }}
                      />
                    </div>
                    <div>
                      <Select
                        label={t("Timezone")}
                        required
                        searchable
                        error={isMissing('timeZone') ? t('Required') : undefined}
                        options={this.state.timeZones.map(x => ({ label: x.displayName, value: x.id }))}
                        value={this.state.item.timeZone || ''}
                        onChange={(value: any) => { const item = { ...this.state.item, timeZone: value }; this.setState({ item }); }}
                      />
                    </div>
                    <div className="md:col-span-2 pt-1">
                      <Checkbox
                        checked={this.state.item.sendWelcomeEmail ?? true}
                        onChange={(ev: React.ChangeEvent<HTMLInputElement>) => { const item = { ...this.state.item, sendWelcomeEmail: ev.target.checked }; this.setState({ item }); }}
                        label={t("Send welcome email")}
                        description={t("The new employee will receive an email with their sign-in details.")}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Employment Details */}
              <div>
                <div className="section h-full">
                  <h3 className="text-sm text-primary mb-2 font-semibold">{t('Employment Details')}</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <Input label={t("Employee Id")} value={this.state.item.employeeId} onChange={(ev: any) => { const item = { ...this.state.item, employeeId: (ev.target as HTMLInputElement).value }; this.setState({ item }) }} />
                    </div>
                    <div>
                      <Input label={t("Title")} value={this.state.item.title} onChange={(ev: any) => { const item = { ...this.state.item, title: (ev.target as HTMLInputElement).value }; this.setState({ item }) }} />
                    </div>
                    <div>
                      <Select
                        label={t("Role")}
                        required
                        error={isMissing('role') ? t('Required') : undefined}
                        options={this.state.roles.map(x => ({ label: x, value: x }))}
                        value={this.state.item.role}
                        onChange={(value: any) => { const item = { ...this.state.item, role: value }; this.setState({ item }) }}
                      />
                    </div>
                    {this.props.role === Roles.Operator && (
                      <div>
                        <Select
                          label={t("Company")}
                          options={this.state.companies.map(x => ({ label: x.name, value: x.id }))}
                          value={this.state.lastSelectedCompany?.id ?? ''}
                          onChange={(value: any) => {
                            const selectedId = value;
                            const selectedCompany = this.state.companies.find(x => x.id === selectedId);
                            const item = { ...this.state.item, companyId: parseInt(String(selectedId)) };
                            this.setState({ lastSelectedCompany: selectedCompany, item }, () => {
                              this.fetchBranchesAndDepartments();
                            });
                          }}
                        />
                      </div>
                    )}
                    <div>
                      <Select
                        label={t("Branch")}
                        options={this.state.branches.map(x => ({ label: x.name, value: x.id }))}
                        value={this.state.item.branchId || ''}
                        onChange={(value: any) => { const item = { ...this.state.item, branchId: parseInt(String(value)) }; this.setState({ item }); }}
                      />
                    </div>
                    <div>
                      <Select
                        label={t("Department")}
                        options={this.state.departments.map(x => ({ label: x.name, value: x.id }))}
                        value={this.state.item.departmentId || ''}
                        onChange={(value: any) => { const item = { ...this.state.item, departmentId: parseInt(String(value)) }; this.setState({ item }) }}
                      />
                    </div>
                    <div>
                      <Select
                        label={t("Employment Type")}
                        options={[
                          { label: t("Full Time"), value: "FullTime" },
                          { label: t("Part Time"), value: "PartTime" },
                          { label: t("Contract"), value: "Contract" },
                          { label: t("Executive"), value: "Executive" }
                        ]}
                        value={this.state.item.employmentType || ''}
                        onChange={(value: any) => { const item = { ...this.state.item, employmentType: value as string }; this.setState({ item }); }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* Social */}
              <div>
                <div className="section h-full">
                  <h3 className="text-sm text-primary mb-2 font-semibold">{t('Social')}</h3>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <Input label={t("LinkedIn Url")} value={this.state.item.linkedInUrl} onChange={(ev: any) => { const item = { ...this.state.item, linkedInUrl: (ev.target as HTMLInputElement).value }; this.setState({ item }); }} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Onboarding Setup */}
            <div className="lg:col-span-2 mt-4">
              <div className="section">
                <h3 className="text-sm text-primary mb-1 font-semibold">{t('Onboarding Setup')}</h3>
                <p className="text-xs text-muted-foreground mb-3">{t('Optionally assign an onboarding process when creating this employee.')}</p>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <Select
                      label={t('Onboarding Template')}
                      options={[
                        { label: t('No onboarding process'), value: '' },
                        ...this.state.onboardingTemplates.map(x => ({
                          label: x.name + (x.isDefault ? ` (${t('Default')})` : ''),
                          value: String(x.id)
                        }))
                      ]}
                      value={this.state.selectedOnboardingTemplateId}
                      onChange={(value: any) => this.setState({ selectedOnboardingTemplateId: value })}
                    />
                  </div>
                  {this.state.selectedOnboardingTemplateId && (
                    <>
                      <div>
                        <label className="text-sm font-semibold mb-0.5 block">
                          {t('Start Date')} <span className="text-destructive">*</span>
                        </label>
                        <input
                          type="date"
                          value={this.state.onboardingStartDate}
                          onChange={(e) => this.setState({ onboardingStartDate: e.target.value })}
                          className={`w-full px-3 py-2 border rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-primary ${isMissing('onboardingStartDate') ? 'border-destructive' : 'border-border'}`}
                        />
                      </div>
                      <div>
                        <Select
                          label={t('Reporting Manager')}
                          required
                          error={isMissing('onboardingManagerId') ? t('Required') : undefined}
                          options={[
                            { label: t('Select a manager...'), value: '' },
                            ...this.state.managers.map(x => ({ label: x.fullName, value: x.id }))
                          ]}
                          value={this.state.onboardingManagerId}
                          onChange={(value: any) => this.setState({ onboardingManagerId: value })}
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            <hr className="border-border mt-2" />
            <div className="flex justify-end mt-2">
              <span title={missing.length ? t('Please complete required fields') : undefined}>
                <Button
                  variant="default"
                  disabled={missing.length > 0 || this.state.isSubmitting}
                  loading={this.state.isSubmitting}
                  onClick={this.submit}
                  data-testid="add-user-submit-btn"
                >
                  {this.state.isSubmitting ? t("Creating...") : t("Submit")}
                </Button>
              </span>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    rtl: state.user.rtl,
    userId: state.user.userId,
    company: state.user.company,
    companyPrimaryColor: state.user.companyPrimaryColor,
    companyName: state.user.companyName,
    role: state.user.role
  }
}
export default connect(mapStateToProps)(withTranslation()(AddUser as any) as any);
